import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from "../actions/notifications"

export default function Notifications(state = [], action) {
  const { payload, type } = action

  switch (type) {
  case ADD_NOTIFICATION:
    return [payload, ...state]
  case REMOVE_NOTIFICATION:
    return state.filter(notification => notification.id !== payload.id)
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notifications.js